/**
 * @file: DeliveryCheckSceneType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum DeliveryCheckSceneType {
  CompletionCheck = 'completion_check',
  SamplingCheck = 'sampling_check',
}

export const DeliveryCheckSceneTypeValueSet = new Set([
  DeliveryCheckSceneType.CompletionCheck,
  DeliveryCheckSceneType.SamplingCheck,
]);
